// removed by extract-text-webpack-plugin
module.exports = {"Label":"_3r87EFkSwrLVaOWtBhLQjg"};


//////////////////
// WEBPACK FOOTER
// ./src/component/Html/P1/style.css
// module id = 1546
// module chunks = 0